import React from "react";
import "./ConfirmationModal.scss";

interface ConfirmationModalProps {
  isVisible: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isVisible,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  if (!isVisible) return null;

  return (
    <>
      <div className="confirmation-modal-overlay" onClick={onCancel} />
      <div className="confirmation-modal-container">
        <div className="confirmation-modal-card">
          <button className="close-btn" onClick={onCancel} aria-label="Close">
            &times;
          </button>
          <h2>{title}</h2>
          <p className="confirmation-message">{message}</p>
          <div className="confirmation-buttons">
            <button
              className="cancel-btn"
              onClick={onCancel}
              disabled={isLoading}
            >
              {cancelText}
            </button>
            <button
              className="confirm-btn"
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? "Processing..." : confirmText}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmationModal;
